const pendienteInitialState = {
    pendiente: {
        loading: false,
        error: null,
        data: null
    },
    pendientePost : {
        loading: false,
        error: null,
        data: null
    }
};

export default pendienteInitialState;